export const getWeekGapCustomEnumMapping = () => {
  return [
    { value: 1, label: 'NT' },
    { value: 2, label: 'C2T' },
    { value: 3, label: 'C3T' },
    { value: 4, label: 'C4T' },
    { value: 5, label: 'C5T' },
  ];
};
